import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './chart.css';
import { Toast } from '../components_root/ToastContext';
import { MdLocationCity } from "react-icons/md";
export const seo = {
    title: "Shopping Cart | Add Items & Continue Your Order on Viabig",
    description: "Easily add items to your shopping cart and continue your order with Viabig. Manage products, review selections, and checkout seamlessly for a smooth shopping experience.",
    keywords: "shopping cart, add to cart, continue order, online shopping, order management, checkout, cart page, viabig cart, buy online",
    url: "https://viabig.com/cart",
    image: "https://viabig.com/assets/logo.png"
};
export default function Chart_root() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>
            <Header />
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Products</h2>
                    <div className='post-container'>
 
                    </div>

                </div>
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Free Services</h2>
                    <div className='post-container'>

                        <div className='ui-grid-100'>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/image-to-pdf')} >Image to  pdf</div>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/favicon-generator')} > Favicon Generator </div>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/word-counter')} >Word counter</div>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/typing-master')} >Typing master</div>
                        </div>
                    </div>

                </div>
            </div>

            <Footers />
            <Navbar />
        </div>
    );
}
